var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelpVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(-16.316 -5.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play_Button",
    "data-name": "Play Button",
    transform: "translate(16.232 5.695)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0.085 0.085)",
    fill: "#5b788f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    d: "M6.413,0l6.413,12.825H0Z",
    transform: "translate(28.321 13.839) rotate(90)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpVideo);
export default __webpack_public_path__ + "static/media/icon_help_video.0419a81c03ea3e063acfb5ed86106f7f.svg";
export { ForwardRef as ReactComponent };